module.exports = __webpack_public_path__ + "static/media/swipe-left-arrow.a528d3c8.svg";